import { Grid } from '@material-ui/core';
import { Typography, BasicBadge, palette } from '@dev/ee-components';
import { isNil } from 'lodash-es';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { useContactsCount, useSelectedEntity } from '@/components/Contacts/Group/hooks';
import { HeaderTitle } from '../../../StyledComponents';

export const TitleWithCount = () => {
    const count = useContactsCount();
    const { selectedEntity, isSelectedEntityAList, getDisplayName } = useSelectedEntity();
    const isList = isSelectedEntityAList(selectedEntity);

    return (
        <Grid container wrap={'nowrap'} alignItems="center">
            <Grid item style={{ overflow: 'hidden' }}>
                <HeaderTitle>
                    <Typography variant="h1">
                        <span>{getDisplayName() || <Skeleton />}</span>
                    </Typography>
                </HeaderTitle>
            </Grid>

            {selectedEntity && !isNil(count) && (
                <Grid item style={{ display: 'flex' }}>
                    <BasicBadge
                        id={`${isList ? 'list' : 'segment'}-count`}
                        style={{
                            fontSize: '14px',
                            fontWeight: 'bold',
                            padding: '4px 12px',
                            borderRadius: '14px',
                            margin: '0 16px',
                        }}
                        textColor={palette.indigo[6]}
                        backgroundColor={palette.gray[1]}
                        value={count}
                    />
                </Grid>
            )}
        </Grid>
    );
};
